import { createLucideIcon } from 'lucide-react';
export const InfoCircleSolid = createLucideIcon('info-circle-solid', [
  [
    'path',
    {
      d: 'M11.9651 10C11.9651 10 11.9653 13.8114 11.9653 18',
      key: 'igfhr1',
    },
  ],
  [
    'path',
    {
      d: 'M11.9651 5C11.9651 5 11.9653 5.95286 11.9653 6.99999',
      key: '1ol9z9',
    },
  ],
  [
    'circle',
    {
      cx: '12',
      cy: '12',
      r: '10',
      key: '1mglay',
    },
  ],
]);

export const FoobarIcon = createLucideIcon('foobar', [
  [
    'path',
    {
      d: 'M 11.965 7 C11.965 9 11.965 5.953 11.965 7',
      key: '1x4odt',
    },
  ],
  [
    'path',
    {
      d: 'M11.9651 10C11.9651 10 11.9653 13.8114 11.9653 18',
      key: 'igfhr1',
    },
  ],
  [
    'circle',
    {
      cx: '12',
      cy: '12',
      r: '10',
      key: '1mglay',
    },
  ],
]);
